import styles from "./index.module.scss";

interface Props {
  color?: any;
  format: string | null | undefined;
  layout:
    | "default"
    | "center"
    | "left"
    | "right"
    | "fixedCenter"
    | "featuredCenter"
    | "bottom"
    | null
    | undefined;
  data: string;
}

const defaultOverlayColor = "#000";

export function OverlayShadow({
  layout,
  color,
  data,
  format,
}: Props): JSX.Element {
  const style = { "--bg": color?.hex ?? defaultOverlayColor } as React.CSSProperties;
  switch (data) {
    case "hdark":
      return (
        <>
          {layout === "right" ? (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowStrongDarkRightVideo}`
                    : `${styles.boxShadowStrongDarkRight}`
                }`}
              ></div>
            </>
          ) : layout === "left" ? (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0  ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowStrongDarkLeftVideo}`
                    : `${styles.boxShadowStrongDarkLeft}`
                }   `}
              ></div>{" "}
            </>
          ) : layout === "bottom" ? (
            <>
              {" "}
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${styles.boxShadowStrongDarkBottom}
                  `}
              ></div>
            </>
          ) : (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowStrongDarkCenterVideo}`
                    : `${styles.boxShadowStrongDarkCenter}`
                }  `}
              ></div>
            </>
          )}
        </>
      );
      break;
    case "sdark":
      return (
        <>
          {layout === "right" ? (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowSoftDarkRightVideo}`
                    : `${styles.boxShadowSoftDarkRight}`
                }  `}
              ></div>
            </>
          ) : layout === "left" ? (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0  ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowSoftDarkLeftVideo}`
                    : `${styles.boxShadowSoftDarkLeft}`
                }   `}
              ></div>{" "}
            </>
          ) : layout === "bottom" ? (
            <>
              {" "}
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${styles.boxShadowSoftDarkBottom}
                  `}
              ></div>
            </>
          ) : (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowSoftDarkCenterVideo}`
                    : `${styles.boxShadowSoftDarkCenter}`
                }  `}
              ></div>
            </>
          )}
        </>
      );
      break;
    case "ldark":
      return (
        <>
          {layout === "right" ? (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowLightDarkRightVideo}`
                    : `${styles.boxShadowLightDarkRight}`
                }  `}
              ></div>
            </>
          ) : layout === "left" ? (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0  ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowLightDarkLeftVideo}`
                    : `${styles.boxShadowLightDarkLeft}`
                }   `}
              ></div>{" "}
            </>
          ) : (
            <>
              <div
                style={style as React.CSSProperties}
                className={` absolute w-full h-full top-0 ${
                  format == "SliderVideoRecord"
                    ? `${styles.boxShadowLightDarkCenterVideo}`
                    : `${styles.boxShadowLightDarkCenter}`
                }  `}
              ></div>
            </>
          )}
        </>
      );
      break;
    case "menuBar":
      return <></>;
      break;
    default:
      return <></>;
      break;
  }
}

export function GenericOverlayShadow({}): JSX.Element {
  const style = { "--bg": "#000" } as React.CSSProperties;
  return (
    <div
      style={style as React.CSSProperties}
      className={` absolute w-full h-full top-0  ${styles.boxShadow}`}
    ></div>
  );
}
